import {z} from 'zod'

import {CreateOrUpdateBlockExternalLinkDocument} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {i18nValidation} from '../../../../../i18n'

import type {BlockExternalLinkInput, CreateOrUpdateBlockExternalLinkMutation} from '@sdox/api'

type UpdateExternalLinkValidatorSchema = z.infer<typeof updateExternalLinkValidatorSchema>

const updateExternalLinkValidatorSchema = z.object({
  data: z.object({
    title: z.string(),
    url: z.string().url({message: i18nValidation.invalidUrl}),
    media: z.object({
      fileHash: z.string(),
    }),
  }),
  meta: updateMetaSchema,
})

export const externalLinkConfig = createFormConfig<
  UpdateExternalLinkValidatorSchema,
  CreateOrUpdateBlockExternalLinkMutation,
  BlockExternalLinkInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockExternalLinkDocument,
  },
  fieldMapper: (fieldValues) => ({
    title: fieldValues.data.title,
    url: fieldValues.data.url,
    mediaHash: fieldValues.data.media.fileHash,
  }),
  validatorSchema: updateExternalLinkValidatorSchema,
  inputFields: [
    {
      label: 'Image',
      fieldName: 'data.media',
      inputType: 'image',
      defaultValue: '',
      required: false,
    },
    {
      label: 'Title',
      fieldName: 'data.title',
      inputType: 'text',
      defaultValue: '',
      required: true,
    },
    {
      label: `URL`,
      fieldName: `data.url`,
      inputType: 'link',
      defaultValue: '',
      required: true,
    },
  ],
})
